import Loading from './src/service'
import vLoading from './src/directive'

import type { App, AppContext, Directive } from 'vue'
import type { ElementLoading, LoadingBinding } from './src/directive'

// installer and everything in all
export const ZLoading = {
  install(app: App) {
    Loading._context = app._context
      ; (
        vLoading as Directive<ElementLoading, LoadingBinding> & {
          _context: AppContext | null
        }
      )._context = app._context
    app.directive('loading', vLoading)
    app.config.globalProperties.$loading = Loading
  },
  directive: vLoading,
  service: Loading,
}

export default ZLoading
export { vLoading, vLoading as ZLoadingDirective, Loading as ZLoadingService }

export * from './src/types'
export type { LoadingInstance } from './src/loading'
